import { useEffect } from 'react';
import Hero from './components/Hero';
import Specialization from './components/Specialization';
import WebsiteAsset from './components/WebsiteAsset';
import WhyProfessional from './components/WhyProfessional';
import SEOFoundation from './components/SEOFoundation';
import WorkProcess from './components/WorkProcess';
import CaseStudiesBlock from './components/CaseStudiesBlock';
import FinalCTA from './components/FinalCTA';
import FAQ from './components/FAQ';
import ExistingSiteHelp from './components/ExistingSiteHelp';
import Footer from './components/Footer';
import { useSEO, getWebPageSchema, getOrganizationSchema, getFAQSchema } from '../../utils/seo';

export default function LandingPage() {
  useSEO({
    title: 'Разработка сайта-стратегии за 7 дней Москва | Системный маркетинг и AI',
    description: 'Превратите ваш бизнес в систему генерации прибыли. Получите не просто сайт, а готовую маркетинговую архитектуру со встроенным SEO, которая продает вашу экспертность или товар 24/7. Разработка сайта за 7 дней в Москве.',
    keywords: 'разработка сайта, создание сайта, сайт под ключ, маркетинговая архитектура, SEO оптимизация, Москва',
    canonical: '/landing-page',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getWebPageSchema(
          'Разработка сайта-стратегии за 7 дней',
          'Превратите ваш бизнес в систему генерации прибыли. Получите готовую маркетинговую архитектуру со встроенным SEO.',
          'SITE_URL/landing-page'
        ),
        getFAQSchema()
      ]
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Specialization />
      <WebsiteAsset />
      <WhyProfessional />
      <SEOFoundation />
      <WorkProcess />
      <CaseStudiesBlock />
      <FAQ />
      <FinalCTA />
      <ExistingSiteHelp />
      <Footer />
    </div>
  );
}